<template>
    <!--
        Form v2 — BranchSection runtime (FormModulePromt §9.5).
        Bu component sadece görsel container/başlık gösterir. Asıl koşul evaluation
        FormContainer'daki conditionEvaluator tarafından yapılır; bu component
        gizliyse FormContainer onu render etmez. Children'lar da hiddenFieldIds'e
        eklenir ve normal akışta otomatik gizlenir.
    -->
    <div v-if="showHeader" class="sf-branch-section">
        <div class="bs-title" v-if="config.title">{{ config.title }}</div>
    </div>
</template>

<script>
export default {
    name: "BranchSection",
    props: {
        value: { type: [Object, String, Number, Array], default: null },
        branchSection: { type: Object, default: () => ({}) },
        label: { type: String, default: "" },
        formId: { type: String, default: "" },
        fieldId: { type: String, default: "" },
        order: { type: Number, default: 0 },
    },
    computed: {
        config() { return this.branchSection || {}; },
        showHeader() {
            // Sadece başlık varsa render et — yoksa görünmez container
            return !!(this.config.title && String(this.config.title).trim().length > 0);
        },
    },
};
</script>

<style lang="scss" scoped>
.sf-branch-section {
    margin: 8px 0;
    padding: 10px 14px;
    background: rgba(6, 182, 212, 0.06);
    border-left: 3px solid #06b6d4;
    border-radius: 0 8px 8px 0;
}

.bs-title {
    font-size: clamp(13px, 1.6vw, 15px);
    font-weight: 600;
    color: #0e7490;
}
</style>
